import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { Schedule } from './components/Schedule';

const EdutainmentSchedule = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="育樂活動表"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '育樂活動表',
            },
          ]}
        />
        <Schedule />
      </Col>
    </Row>
  );
};

export default EdutainmentSchedule;
